---
title: "Conditions générales"
path: "/fr/conditions-generales-dutilisation"
seoTitle: "Conditions générales | Dutch Passion Thailand"
seoDescription: "Résumé des conditions de commande, de paiement, de livraison et de retour des graines de cannabis Dutch Passion en Thaïlande. À lire avant de commander."
---

> **Cette version française est un résumé, produit par traduction automatique.**
> Seules les [conditions générales en anglais](/terms-and-conditions) font foi. En cas de
> divergence, la version anglaise prévaut. Cette page attend une relecture par un locuteur natif.

## Champ d’application

Ces conditions s’appliquent à toute commande passée sur dutchpassion.co.th. En validant votre
commande, vous les acceptez.

## Commande et paiement

Les prix sont indiqués en bahts thaïlandais, taxe comprise. Vous pouvez payer à la livraison,
par carte de crédit ou de débit, via PromptPay ou par banque mobile. Les données de carte sont
transmises directement à notre prestataire Omise et ne transitent jamais par ce site.

## Livraison

Les commandes passées avant 15h un jour ouvré sont expédiées le jour même. L’emballage est
discret : rien à l’extérieur n’indique le contenu. Nous livrons uniquement en Thaïlande : la livraison
postale standard coûte 100 THB partout dans le pays, Bangkok compris, et arrive normalement sous 1 à 3
jours ouvrés. À Bangkok, la livraison le jour même est proposée en option supplémentaire pour 250 THB.

## Annulation et retours

Tant que la commande n’a pas été expédiée, vous pouvez l’annuler ou la modifier en nous écrivant
avec votre numéro de commande. Les graines ne sont pas reprises, sachet ouvert ou non, et les commandes livrées ne
sont pas remboursées. Contactez-nous si un article est défectueux ou ne correspond pas
à la commande.

## Droit applicable

Ces conditions sont régies par le droit thaïlandais. Pour toute question :
info@dutchpassion.co.th.
